export enum MyProjectsPage {
  PROCESSING = 'Your file is being processed. Please check the status here for when processing is complete.',
  PROCESSED = 'Processing of your file is Complete. Please select for next step.',
  READY = 'Your data is ready for Analysis. Please select to go to the final step.',
  CLEANING = 'Your data is being Cleaned. Please check the status here for when cleaning is complete.',
  ERROR = 'Your file is corrupt. Request you to look at ‘Want to know more about Importing data into DS’ section and upload again.',
  DELETE_PROJECT = 'Delete Project'
}

export const GO_BACK_MESSAGE = 'Go back to Dashboard';
